import React, { lazy } from 'react';
import { GiftIcon } from 'lucide-react';
import { useCurrency } from '../hooks/useCurrency';
interface BonusCardProps {
  number: number;
  title: string;
  value: number;
  description: string;
  delay?: number;
  imageUrl?: string;
}
export function BonusCard({
  number,
  title,
  value,
  description,
  imageUrl
}: BonusCardProps) {
  const {
    formatPrice,
    isLoading
  } = useCurrency();
  return <div className="bg-[var(--bg-card)] rounded-xl overflow-hidden border-2 border-[var(--accent-orange)]/30 hover:border-[var(--accent-orange)] transition-colors duration-300" data-id="element-52">
      <div className="bg-gradient-to-r from-[var(--accent-orange)] to-[var(--accent-orange-hover)] p-2 md:p-3" data-id="element-53">
        <div className="flex items-center gap-2 md:gap-3" data-id="element-54">
          <GiftIcon className="w-4 h-4 md:w-6 md:h-6 text-white" aria-hidden="true" data-id="element-55" />
          <span className="text-sm md:text-lg font-bold text-white" data-id="element-56">
            BONO #{number}
          </span>
        </div>
      </div>

      {imageUrl && <div className="w-full aspect-square overflow-hidden bg-gray-100" data-id="element-57">
          <img src={imageUrl} alt={title} className="w-full h-full object-contain" loading="lazy" decoding="async" width={400} height={400} data-id="element-58" />
        </div>}

      <div className="p-3 md:p-4" data-id="element-59">
        <h3 className="text-base md:text-xl lg:text-2xl font-bold text-[var(--text-light)] mb-2 md:mb-3" data-id="element-60">
          {title}
        </h3>
        <p className="text-lg md:text-2xl lg:text-3xl font-black text-[var(--accent-orange)] mb-2 md:mb-3" data-id="element-61">
          Valor Real: {isLoading ? '...' : formatPrice(value)}
        </p>
        <p className="text-sm md:text-base lg:text-lg text-[var(--text-gray)] mb-2 md:mb-3 leading-relaxed" data-id="element-62">
          {description}
        </p>
        <div className="inline-block bg-[var(--accent-orange)]/20 px-3 py-1.5 md:px-4 md:py-2 rounded-lg" data-id="element-63">
          <p className="text-sm md:text-base lg:text-lg font-bold text-[var(--accent-orange-light)]" data-id="element-64">
            Tuyo GRATIS
          </p>
        </div>
      </div>
    </div>;
}